import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import LanguageToggle from './LanguageToggle';
import { useLanguageUrl } from '../utils/languageUtils';
import { getImageUrl } from '../utils/imageUtils';

const Header = () => {
  const { t } = useTranslation();
  const { getLanguageUrl } = useLanguageUrl();
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleNavigation = (sectionId) => {
    // If we're on the homepage, scroll to section
    if (location.pathname === '/' || location.pathname.match(/^\/[a-z]{2}$/)) {
      scrollToSection(sectionId);
    } else {
      // If we're on another page, navigate to homepage with section
      navigate(getLanguageUrl('/'));
      // Scroll to section after navigation
      setTimeout(() => scrollToSection(sectionId), 100);
    }
  };

  return (
    <header className="sticky top-0 z-40 bg-white/80 backdrop-blur border-b">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          {/* Logo */}
          <Link to={getLanguageUrl('/')} className="flex items-center gap-3">
            <div className="h-8 w-8 rounded-xl bg-gradient-to-br from-white to-white">
              <img 
                src={getImageUrl("/images/tapngrab_logo_s.png")} 
                alt="Tap'nGrab" 
                className="w-full h-full object-contain"
              />
            </div>
            <span className="font-semibold">Tap'nGrab</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8 text-sm">
            <button 
              onClick={() => handleNavigation('why')}
              className="hover:text-slate-900"
            >
              {t('nav.why')}
            </button>
            <button 
              onClick={() => handleNavigation('features')}
              className="hover:text-slate-900"
            >
              {t('nav.features')}
            </button>
            <button 
              onClick={() => handleNavigation('use')}
              className="hover:text-slate-900"
            >
              {t('nav.use_cases')}
            </button>
            <button 
              onClick={() => handleNavigation('how')}
              className="hover:text-slate-900"
            >
              {t('nav.how')}
            </button>
            <Link 
              to={getLanguageUrl('/contact')}
              className="hover:text-slate-900"
            >
              {t('nav.contact')}
            </Link>
          </nav>

          {/* Right side: Language toggle + CTA */}
          <div className="flex items-center gap-4">
            <LanguageToggle />
            <Link 
              to={getLanguageUrl('/request-placement')}
              className="hidden sm:inline-block rounded-xl px-4 py-2 text-sm font-semibold text-white glow"
              style={{ background: 'linear-gradient(90deg, #06b6d4, #3b82f6, #6366f1)' }}
            >
              {t('nav.cta_primary')}
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
